export function header() {
  const header = document.querySelector('.header');
  const burger = document.querySelector('.header__burger');
  const body = document.body;

  if (!header) return;

  // Sticky background on scroll
  const handleScroll = () => {
    if (window.scrollY > 50) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  // Burger menu toggle
  if (burger) {
    burger.addEventListener('click', () => {
      body.classList.toggle('is-menu-open');
      body.classList.toggle('scroll-lock');
    });

    // Close menu on nav link click
    const navLinks = document.querySelectorAll('.header__menu a');
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        body.classList.remove('is-menu-open');
        body.classList.remove('scroll-lock');
      });
    });
  }
}
